import { css } from '@emotion/core';

export const datePickerWrapperStyle = css`
    cursor: default;
    display: inline-block;
`;
